import React from 'react';

import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { useRiskRegisterStore } from 'store/riskRegister.store';

import { Risk } from 'api/queries/getRiskRegister.query';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/icon';
import { TableRef } from 'components/common/Tables/TableV8/tableV8';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import { CustomizedButton, CustomizedModalBase, CustomizedTooltip } from 'components/common';
import { getRisksNames } from 'components/widgets/RiskRegister/components/RunQsra/RunQsra.utils';
import { RunQsraForm } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm';

interface Props {
    latestVersionId: number;
    tableRef: React.RefObject<TableRef<Risk>>;
}

export const RunQsra = ({ latestVersionId, tableRef }: Props) => {
    const { update, showModal } = useRiskRegisterStore();
    const { sendEventWithDimensions } = useEventWithDimensions();
    const handleModalClose = () => {
        update({ showModal: false });
    };

    const riskIds = tableRef.current?.table.getSelectedRowModel().flatRows.map((item) => item.original.id) ?? [];

    const riskNames = tableRef.current?.table.getSelectedRowModel().flatRows.map((item) => item.original.name) ?? [];

    const handleClick = () => {
        update({ showModal: true, runQsra: null });
        sendEventWithDimensions({ action: 'Run QSRA', label: getRisksNames(riskNames), category: 'Risk Register' });
    };
    return (
        <>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Top}
                tooltipContent={`Run QSRA`}
                triggerElement={
                    <CustomizedButton
                        startIcon={<MuiIcon icon={'autorenew'} color={'#2C8FA5'} />}
                        color={'secondary'}
                        onClick={handleClick}
                        disabled={riskIds.length === 0}
                    >
                        Run QSRA
                    </CustomizedButton>
                }
            />
            <CustomizedModalBase isModalOpen={showModal} handleModalClose={handleModalClose}>
                <RunQsraForm latestVersionId={latestVersionId} riskIds={riskIds} handleModalClose={handleModalClose} />
            </CustomizedModalBase>
        </>
    );
};
